import { Toaster } from 'react-hot-toast'

/** Global toast host. Mounted once by AppProviders. */
export function ToastProvider() {
  return (
    <Toaster
      position="top-right"
      gutter={8}
      toastOptions={{
        duration: 4000,
        // Tokens only — no hardcoded colours.
        className: 'text-sm',
        style: {
          background: 'var(--color-surface)',
          color: 'var(--color-fg)',
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-md)',
          boxShadow: '0 4px 16px oklch(0 0 0 / 0.08)',
        },
        success: {
          iconTheme: { primary: 'var(--color-success)', secondary: 'var(--color-surface)' },
        },
        error: {
          duration: 6000,
          iconTheme: { primary: 'var(--color-danger)', secondary: 'var(--color-surface)' },
        },
      }}
    />
  )
}
